import { useKeycloakAuthContext } from '@components/AuthContext';

/** This is the keycloak user, NOT the "user" object for mastermind that has historically been kept inside whoAmI query/service */
export const useKeycloakUser = (): Keycloak.KeycloakProfile | null => {
  const { user: currentUser } = useKeycloakAuthContext();
  return currentUser?.email ? currentUser : null;
};
